import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RouterModule } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { FormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LogoutComponent } from './logout/logout.component';
import { GlobalLoaderComponent } from './global-loader/global-loader.component';
import { ValidatorsModule } from '../validators/validators.module';
import { PasswordResetModule } from './password-reset/password-reset.module';
import { RevertSecondFactorModule } from './revert-second-factor/revert-second-factor.module';
import { SignupComponent } from './signup/signup.component';
import { CheckboxModule } from 'primeng/checkbox';
import { PipesModule } from '../pipes/pipes.module';
import { InvalidLinkModule } from './invalid-link/invalid-link.module';

@NgModule({
  declarations: [
    LoginComponent,
    ShellComponent,
    ForgotPasswordComponent,
    LogoutComponent,
    GlobalLoaderComponent,
    SignupComponent,
  ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ValidatorsModule,
        PasswordResetModule,
        RevertSecondFactorModule,
        CheckboxModule,
        PipesModule,
      InvalidLinkModule,
    ],
  exports: [
    GlobalLoaderComponent,
  ]
})
export class PublicModule { }
